export enum ChartTypes {

    operating = 'operating',
    minMax = 'minMax',
    series = 'series'

}
